export default "__VITE_ASSET__9F_lomoy__"